export default "__VITE_ASSET__BQz7yWxh__"